import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import LastBought from './LastBought';
import Reviews from './Reviews';

export default class LastBoughtOrReviews extends PureComponent {
  static propTypes = {
    lastBoughtDate: PropTypes.string,
    reviewStats: PropTypes.shape({
      averageRate: PropTypes.number,
      count: PropTypes.number,
      showCount: PropTypes.bool,
    }),
  };

  renderContent() {
    const {
      lastBoughtDate,
      reviewStats: { averageRate, count, showCount },
    } = this.props;

    if (!lastBoughtDate && !averageRate) {
      return null;
    }

    if (lastBoughtDate) {
      return (
        <LastBought lastBoughtDate={lastBoughtDate} />
      );
    }

    return <Reviews averageRate={averageRate} count={showCount ? count : -1} />;
  }

  render() {
    return (
      <div className="review-wrapper">
        {this.renderContent()}
      </div>
    );
  }
}
